import { render, staticRenderFns } from "./modal-language-picker.vue?vue&type=template&id=1a85029e"
import script from "./modal-language-picker.vue?vue&type=script&lang=js"
export * from "./modal-language-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports